/**
* Created by wangwanda on 2018/12/5.
*/
<template>
  <div class="register">
    <div :class="{mask: true,hide: maskFlag}">
      <div style="position: relative;top: 50%;">
        <Spin>
          <Icon type="load-c" size="50" class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>
    </div>
    <div class="header">
      <img src="../../../assets/images/init.png" style="cursor: pointer" @click="gologin">
    </div>
    <div id="shadow">
      <img src="../../../assets/images/shadow.png">
    </div>

    <div class="registerWarp">
      <div style="width: 436px;margin: auto">
        <img src="../../../assets/images/dangjian.png">
      </div>
      <div class="pBox">
        <input
          class="serach"
          placeholder="请搜索社区"
          v-model="inputDistrict"
          ref="inputDistrict"
          @blur="searchBlur"
          @focus.prevent="searchFocus"
        >
        <Scroll class="sConten" :on-reach-bottom="handleReachBottom" height="300" :distance-to-edge="-50" v-show="!flag">
          <ul>
            <li
              v-for="district in districtList"
              @click="selectItem(district)"
              :key="district.communityId"
            >
              <div class="s-title">{{district.communityName}}</div>
              <div class="s-introduce">{{district.pathName}}</div>
            </li>
          </ul>
        </Scroll>

        <div class="icon-close-box" @click="clearDistrict">
          <svg class="icon-close" aria-hidden="true">
            <use xlink:href="#icon-guanbi-copy"></use>
          </svg>
        </div>
      </div>
      <input class="division" placeholder="系统名称" v-model="systemName">
      <input class="division" placeholder="手机号" v-model="phoneNO">
      <div class="sure bc-color" @click="register">确定</div>
    </div>
    <div class="footer">
      <div class="foot-logo">
        <img src="../../../assets/images/bkcc.png" alt>
      </div>
      <p>北京北科互联城市治理技术研究院有限公司&nbsp;&nbsp;&nbsp;&nbsp;
        <a class="icp" target="_blank" href="https://beian.miit.gov.cn/">京ICP备19000636号-1</a>
      </p>
    </div>
  </div>
</template>
<script type="es6">
import photoSrc from "../../../assets/images/photo.png";
export default {
  name: "register",
  data() {
    return {
      src: photoSrc,
      flag: true,
      inputDistrict: "",
      systemName: "",
      cityList: [],
      districtList: [],
      currentDistrict: {},
      maskFlag: true,
      pageNum: 1,
      pageSize: 20,
      districtComplete: false, // 搜索结果加载完成
      curValue: "", // 当前要搜索的值
      phoneNO:'',
    };
  },
  components: {
  },
  created: function() {
    this.debounceSearchResult = this._.debounce(this.searchResult, 500);
  },
  watch: {
    inputDistrict: function(val) {
      // 输入值有变化时触发
      this.curValue != val &&
        this.debounceSearchResult({
          val: val,
          refresh: true
        });
      this.curValue = val;
    }
  },
  methods: {
    register: function() {
      if (!this.inputDistrict) {
        this.$Message.info("请先选择行政区域");
        return;
      }
      if (this.inputDistrict && this.systemName) {
        var vm = this;
        var url = this.urlobj.register;
        this.$post(url, {
          communityId: this.currentDistrict.communityId,
          sysName: this.systemName,
          communityName: this.currentDistrict.communityName,
          phoneNO:this.phoneNO
        })
          .then(function(response) {
            console.log(response);
            if (response.isSucceed) {
              vm.$store.commit(
                "updateCommunity",
                vm.currentDistrict.strretOrCommunity
              );
              vm.$store.commit(
                "updateCommunityid",
                vm.currentDistrict.communityId
              );
              vm.$store.commit("updateCityCode", response.newPrimaryKeys.code);
              vm.$store.commit("updateCityLatLng", response.newPrimaryKeys.gps);
              vm.$store.commit(
                "updateIsAdmin",
                response.newPrimaryKeys.isManager
              );
              vm.$store.commit("updateSystemName", vm.systemName);
              vm.$router.push("/AuditPage");
            } else {
              vm.$Message.info(response.message);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        this.$Notice.error({
          desc: "行政区域和系统名不能为空!"
        });
      }
    },
    // 无限滚动
    handleReachBottom() {
      console.log('触底')
      if (!this.districtComplete) {
        return new Promise((resolve, reject) => {
          ++this.pageNum;
          this.searchResult({
            val: this.curValue
          }).then(() => {
            resolve();
          });
        });
      }
    },
    /* 搜索街道列表
      val : 搜索的name 值
      refresh ：是否需要重新搜索
    */
    searchResult({ val = "", refresh = false } = {}) {
      return new Promise((resolve, reject) => {
        let that = this;
        let url = this.urlobj.register;
        if (refresh) {
          this.pageNum = 1;
          this.districtComplete = false // 刷新时重置状态
        }
        let data = {
          name: val,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        };
        this.$get(url, data)
          .then(res => {
            if (res.isSucceed) {
              let resList = res.rows.map(item => {
                return {
                  communityName: item.communityName,
                  communityId: item.communityId,
                  pathName: item.pathName
                };
              });
              if (refresh) {
                this.districtList = resList;
              }
              if (!refresh) {
                this.districtList.push(...resList);
              }
              // 数据加载完成
              if (res.rows.length < this.pageSize) {
                this.districtComplete = true;
              }
            }
            resolve(res);
          })
          .catch(e => reject(e));
      });
    },
    imgChange: function(e) {
      console.log(e);
      var file = e.target.files || e.dataTransfer.files;
      console.log(e.target.value);
      console.log(file);
      if (typeof FileReader === "undefined") {
        alert("您的浏览器不支持图片上传，请升级您的浏览器");
        return false;
      }
      var image = new Image();
      var vm = this;
      var leng = file.length;
      for (var i = 0; i < leng; i++) {
        var reader = new FileReader();
        reader.readAsDataURL(file[i]);
        reader.onload = function(e) {
          console.log(e.target.result);
          vm.src = e.target.result;
          vm.upload();
        };
      }
    },
    upload() {
      this.maskFlag = false;
      var fileObj = document.getElementById("file").files[0];
      var form = new FormData();
      form.append("file", fileObj);
      //form.append("id",id);
      var vm = this;
      var url =
        this.$store.state.serverHost +
        "cmy/cmy/sCommunityinfo/uploadCommunityPic";
      this.$http
        .post(url, form)
        .then(function(response) {
          console.log(response);
          vm.$store.state.nav.photo = response.data.filepath;
          vm.src = response.data.filepath;
          vm.maskFlag = true;
          console.log(vm.src);
        })
        .catch(function(error) {
          vm.maskFlag = true;
          console.log(error);
        });
    },
    selectItem(district) {
      this.curValue = district.communityName; // 更新当前值
      this.inputDistrict = district.communityName; // 更新显示值
      this.systemName = district.communityName + "系统"; // 更新系统名
      this.currentDistrict = district;
      // this.$refs.inputDistrict.disabled = true;
    },
    searchBlur() {
      var vm = this;
      setTimeout(() => {
        vm.flag = true;
      }, 500);
    },
    searchFocus() {
      var vm = this;
      setTimeout(() => {
        vm.flag = false;
      }, 500);
    },
    gologin() {
      this.$router.push("/");
    },
    clearDistrict() {
      this.$refs.inputDistrict.disabled = false;
      this.inputDistrict = "";
    }
  }
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}
.register {
  width: 100%;
  height: 100%;
}
.header {
  width: 1200px;
  height: 91px;
  margin: 0 auto;
  line-height: 91px;
  font-size: 30px;
  color: #3c7ce6;
  font-weight: bold;
}
.header img {
  margin-top: 35px;
}
.header span {
  font-size: 14px;
  color: #666;
  font-weight: 400;
  float: right;
}
#shadow img {
  width: 100%;
}
.registerWarp {
  width: 600px;
  height: 495px;
  margin: 120px auto 0;
  font-size: 14px;
}
.photo {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  border-radius: 50%;
}
.photo img {
  width: 120px;
  height: 120px;
}

.doubleBox {
  height: 56px;
  margin-top: 60px;
}
.pBox {
  height: 50px;
  background: #fff;
  border: 1px solid #d7dde4;
  color: #333;
  font-size: 20px;
  position: relative;
  border-radius: 5px;
}
.pBox img {
  margin: 21px 13px 0 11px;
  vertical-align: top;
}
.pBox select {
  width: 84px;
  height: 33px;
  margin-top: 8px;
  padding: 0 10px;
  border: none;
  outline: none;
  border-right: 1px solid #d7dde4;
}
.pBox select option {
  height: 48px;
  line-height: 48px;
}
.sConten {
  width: 600px;
  position: absolute;
  top: 52px;
  left: 0px;
  border-radius: 5px;
  box-shadow: 0 5px 10px #aaa;
  background: #fff;
}
.sConten li {
  padding: 10px 15px 5px;
  border-bottom: 1px solid #eee;
}
.sConten li:hover {
  cursor: pointer;
  background: #ccc;
}
.s-title {
  line-height: 20px;
}
.s-introduce {
  font-size: 16px;
  line-height: 20px;
  color: #999;
}
.serach {
  width: 598px;
  height: 48px;
  line-height: 48px;
  background: #fff;
  border: none;
  padding-left: 19px;
  font-size: 16px;
  border-radius: 5px;
}
.division {
  width: 600px;
  height: 50px;
  margin-top: 36px;
  background: #fff;
  border: 1px solid #d7dde4;
  padding-left: 19px;
  border-radius: 5px;
}
.sure {
  height: 50px;
  margin-top: 36px;
  line-height: 56px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}
.phoneBox {
  width: 400px;
  height: 56px;
  float: left;
  background: #fff;
}
.verBox {
  width: 192px;
  height: 56px;
  float: right;
  background: #fff;
}
.doubleBox img {
  width: 26px;
  height: 26px;
  margin-top: 15px;
  margin-left: 17px;
  vertical-align: top;
  border: none;
}
.phone {
  width: 230px;
  height: 38px;
  margin-top: 9px;
  margin-left: 17px;
  padding-left: 10px;
  border: none;
  outline: none;
  border-left: 1px solid #ddd;
}
.code {
  width: 130px;
  height: 38px;
  margin-top: 9px;
  margin-left: 17px;
  padding-left: 10px;
  border: none;
  outline: none;
  border-left: 1px solid #ddd;
}
.ver {
  width: 105px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  background: #f1f1f1;
  float: right;
}

.footer {
  width: 100%;
  margin-top: 70px;
  text-align: center;
  color: #666;
}
.footer p {
  margin-top: 10px;
}
.logo {
  height: 80px;
  text-align: left;
}
.logoIcon {
  display: inline-block;
  position: relative;
  top: 5px;
}
.title {
  display: inline-block;
  margin-left: 10px;
  font-size: 20px;
  font-family: "MFLangQian_Noncommercial";
  color: rgb(50, 155, 229);
  position: relative;
  top: 13px;
}
.title > div {
  font-size: 16px;
  font-family: "Aparajita";
  position: relative;
  top: -9px;
}
.content {
  width: 80%;
  margin: 0 auto;
}
.userInfo {
  margin-top: 50px;
}
.ivu-input-group-append {
  background-color: #329be5;
  color: #fff;
}

.a-upload {
  width: 90px;
  height: 30px;
  line-height: 28px;
  border: 1px solid #dedddd;
  margin: 16px auto 54px;
  background: #f6f5f5;
  text-align: center;
  color: #999;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  display: block;
}
.a-upload input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
}

.a-upload:hover {
  color: #444;
  background: #eee;
  border-color: #ccc;
  text-decoration: none;
}
.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(55, 55, 55, 0.6);
  height: 100%;
  z-index: 1000;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.icon-close {
  width: 14px;
  height: 14px;
  fill: #ccc;
}
.icon-close-box {
  position: absolute;
  right: 10px;
  top: 50%;
  display: none;
  transform: translate(0, -50%);
  cursor: pointer;
}
.pBox:hover .icon-close-box {
  display: block;
}
</style>
